import { useEffect, useState } from "react";
import { generator as generatorActions } from "@/repositories/generator";
import { Generator } from "@/models";
import Spinner from "@/components/base/Spinner";
import { Link } from "react-router-dom";
import { Button } from "@/components/base/Button";
import { ExternalLinkIcon } from "lucide-react";
export const GeneratorCell = ({
  tenantId,
  generatorId,
}: {
  tenantId: string;
  generatorId: string;
}) => {
  const [loading, setLoading] = useState(true);
  const [generator, setGenerator] = useState<Generator>();

  useEffect(() => {
    generatorActions
      .get(generatorId, tenantId)
      .then((res) => setGenerator(res))
      .finally(() => setLoading(false));
  });

  if (loading) {
    return <Spinner />;
  }

  if (!generator) {
    return null;
  }
  return (
    <div className="flex flex-row justify-between gap-4 items-center">
      <span>{`${generator.make} ${generator.modelNumber}: ${generator.serialNumber}`}</span>
      <Link to={`/app/${tenantId}/generators/${generator.id}`} target="_blank">
        <Button variant="outline" size={"icon"}>
          <ExternalLinkIcon />
        </Button>
      </Link>
    </div>
  );
};
